import { Typography, Grid, Chip } from "@material-ui/core";
import millify from "millify";
import { useState } from "react";
import NumberFormat from "react-number-format";
import Ratings from "../../../constants/Rating";
import CompanyChart from "./CompanyChart";
import { url } from "../../../constants";
import ListCardMobile from "./ListCardMobile";

export default function ETFCardMobile(props) {
  const { Company, tabValue, t, clickable, setCompanyDetail } = props;
  const Assets = Company?.Assets_Under_Management?.toString().split(".");
  const AssetsInt = Assets ? Assets[0]?.length : 0;
  const [noLogo, setNoLogo] = useState(false);
  const [yearlyView, setYearlyView] = useState(false);
  const [monthlyView, setMonthlyView] = useState(false);
  const [changeGraph, setChangeGraph] = useState(false);

  return (
    <div
      style={
        {
          //padding: "14px 15px 15px 11px"
        }
      }
    >
      <ListCardMobile
        Company={Company}
        tabValue={tabValue}
        setCompanyDetail={setCompanyDetail}
        clickable={clickable}
        t={t}
        etf={true}
      />

      {/* <Grid item xs={12} style={{ display: "flex" }}>
        <Grid item xs={6} style={{ display: "flex" }}>
          <Typography
            style={{
              color: "#808080",
              fontSize: "14px",
              fontFamily: "Overpass",
              height: "18px",
              margin: "1px 36px 10px 0",
            }}
          >
            {Company?.ISIN}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Typography
            style={{
              height: "15px",
              margin: "2px 7px 4px 0",
              fontFamily: "Overpass",
              fontSize: "12px",
              color: "#808080",
            }}
          >
            {Company?.Country}
          </Typography>
          <img
            alt="logo"
            style={{ height: "21px", marginLeft: "7px" }}
            src={`${url}/static/CountryFlag/${Company?.Country}.jpg`}
          ></img>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography
          style={{
            color: "#16063b",
            fontSize: "18px",
            fontWeight: 900,
            fontFamily: "Overpass",
            margin: "0px 0px 4px 0",
            cursor: "pointer",
          }}
          onClick={() => {
            props.setCompanyDetail(Company?.ISIN);
          }}
        >
          {Company?.Name}
        </Typography>
      </Grid>
      <Typography
        style={{
          color: "#0040ff",
          fontSize: "13px",
          fontWeight: 800,
          fontFamily: "Overpass",
          height: "15px",
          margin: " 4px 3px 25px 0",
          lineHeight: 1.15,
        }}
      >
        {Company?.Sector ? Company.Sector : Company?.Issuer}
      </Typography>
      <Grid item xs={12} style={{ display: "flex" }}>
        <Grid>
          <div
            style={{
              width: "136px",
              height: "159px",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 0 11px 0 #16063b26",
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => {
              props.setCompanyDetail(Company?.ISIN);
            }}
          >
            {!Company?.logos ? (
              <Typography
                style={{
                  fontFamily: "Overpass",
                  fontSize: "14px",
                  textAlign: "center",
                  color: "#808080",
                  maxWidth: "75px",
                }}
              >
                NO LOGO AVAILABLE
              </Typography>
            ) : (
              <img
                src={
                  Company?.logos
                    ? `${url}/static/ISINlogo/${Company?.logos}`
                    : "https://coolbackgrounds.io/images/backgrounds/white/pure-white-background-85a2a7fd.jpg"
                }
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "75px",
                  height: "auto",
                  padding: "0 8px 0 8px",
                }}
                onError={(e) => {
                  setNoLogo(!noLogo);
                }}
              />
            )}
          </div>
        </Grid>
        <Grid style={{ margin: "0px 7px 5px 23px" }}>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontFamily: "Overpass",
            }}
          >
            {props.t("inception_date")}
          </Typography>
          <Typography
            style={{
              color: Company?.OneDayPrice >= 0 ? "#259D23" : "#e11c1c",
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {Company?.Inception_Date}
          </Typography>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontFamily: "Overpass",
              marginTop: "5px",
            }}
          >
            {props.t("price")}
          </Typography>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {`${Company?.Price} ${Company?.Currency ? Company?.Currency : ""}`}
          </Typography>
          <Typography
            style={{
              color: "#808080",
              marginTop: "5px",
              fontSize: "12px",
              fontFamily: "Overpass",
            }}
          >
            {props.t("assets_under_management")}
          </Typography>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {AssetsInt < 7 ? (
              millify(
                Company?.Assets_Under_Management
                  ? Company?.Assets_Under_Management
                  : 0,
                {
                  units: ["M USD", "B USD"],
                  space: true,
                  precision: 2,
                }
              )
            ) : (
              <NumberFormat
                value={
                  Company?.Assets_Under_Management
                    ? Company?.Assets_Under_Management / 1000
                    : 0 / 1000
                }
                thousandSeparator={"'"}
                displayType="text"
                suffix={" B USD"}
                decimalScale={2}
              />
            )}
          </Typography>
          <Grid item xs={12} style={{ display: "flex" }}>
            <Chip
              style={{
                height: "20px",
                margin: "18px 12px 35px 0px",
                borderRadius: "10px",
                fontFamily: "Overpass",
                fontWeight: "bold",
                fontSize: "10px",
                boxSizing: "border-box",
                color: "#0040ff",
                backgroundColor: "#adc7fe",
              }}
              label="ETF"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          marginTop: "34px",
        }}
      >
        <Ratings value={parseInt(Company?.valuation)} label="FAIR PRICE" />
        <Ratings value={parseInt(Company?.future)} label="POTENTIAL" />
        <Ratings value={parseInt(Company?.past)} label="PAST HISTORY" />
        <Ratings value={parseInt(Company?.health)} label="SOLVENCY" />
        <Ratings value={parseInt(Company?.dividend)} label="EARNINGS" />
      </Grid>
      {Company?.Graph ? (
        <>
          <div
            style={{
              //   height: "100%",
              //   backgroundColor: "#FAFAFA",
              width: "100%",
              margin: "33px 0 0px 0",
            }}
          >
            <CompanyChart
              ISIN={Company?.ISIN}
              yearlyView={yearlyView}
              monthlyView={monthlyView}
              changeGraph={changeGraph}
            />
          </div>
          <Grid item xs={12} style={{ display: "flex" }}>
            <Chip
              label="1M "
              onClick={() => {
                setYearlyView(false);
                setMonthlyView(false);
                setChangeGraph(!changeGraph);
              }}
              style={{
                borderRadius: "10px",
                color: !yearlyView && !monthlyView ? "#f8f8f8" : "#808080",
                backgroundColor:
                  !yearlyView && !monthlyView ? "#0040ff" : "#f8f8f8",
                height: "20px",
                width: "100%",
                margin: "41px 30px 0 10px",
                fontSize: "10px",
                fontWeight: 400,
                fontFamily: "Overpass",
                display: "flex",
                alignItems: "center",
              }}
            />
            <Chip
              label="YTD"
              onClick={() => {
                setMonthlyView(true);
                setYearlyView(false);
                setChangeGraph(!changeGraph);
              }}
              style={{
                borderRadius: "10px",
                color: monthlyView ? "#f8f8f8" : "#808080",
                backgroundColor: monthlyView ? "#0040ff" : "#f8f8f8",
                marginRight: "10px",
                height: "20px",
                margin: "41px 30px 0 10px",
                fontSize: "10px",
                fontWeight: 400,
                fontFamily: "Overpass",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            />

            <Chip
              label="ALL"
              onClick={() => {
                setYearlyView(true);
                setMonthlyView(false);
                setChangeGraph(!changeGraph);
              }}
              style={{
                borderRadius: "10px",
                color: yearlyView ? "#f8f8f8" : "#808080",
                backgroundColor: yearlyView ? "#0040ff" : "#f8f8f8",
                marginRight: "10px",
                height: "20px",
                margin: "41px 30px 0 10px",
                fontSize: "10px",
                fontWeight: 400,
                fontFamily: "Overpass",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            />
          </Grid>{" "}
        </>
      ) : null} */}
    </div>
  );
}
